module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4wMZAw0GaD7EaAAAAQ5JREFUSMftlDFKQ0EQhr/3iigWgjYSCYrYyRzAwkYweIfcYSo7D+AF5iSWomCpBxjSiSABsRGLRLR6KUIQ3ttgeDtpxL/cneVj//ln4K+oaPXKvAL6wAMqk9/Ky5YAgFvgeJknZUvAXHexEPNXoGrjbrkk4AnYSfRwE/MiH2I+Ag4aAJUCGKNS5aXLfAJsNM5ngIAIm38Ba7mAxXaZvyQBsB3TePNToJeoPQI+VpeuTJUJz++BUaJ2CGzF/URlD/hO3Fxj3omzS2Ud+KydniyAZ27h2TDu1mpvgAEq7zGNV+kBz7W9dQ5cYr4fly6VQ+CtBroABrERVukm7L2Kn5PmSjlbzTD+gPrAI/+K1hSsLj5YhPcfxQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/back.png
// module id = 31
// module chunks = 1